export default {
  'DATE.JAN': '1月',
  'DATE.FEB': '2月',
  'DATE.MAR': '3月',
  'DATE.APR': '4月',
  'DATE.MAY': '5月',
  'DATE.JUN': '6月',
  'DATE.JUL': '7月',
  'DATE.AUG': '8月',
  'DATE.SEP': '9月',
  'DATE.OCT': '10月',
  'DATE.NOV': '11月',
  'DATE.DEC': '12月',

  'WEEK.SUN': '日曜日',
  'WEEK.MON': '月曜日',
  'WEEK.TUE': '火曜日',
  'WEEK.WED': '水曜日',
  'WEEK.THU': '木曜日',
  'WEEK.FRI': '金曜日',
  'WEEK.SAT': '土曜日',

  'GENDER.MALE': '男性',
  'GENDER.FEMALE': '女性',
  'GENDER.OTHER': 'その他',

  'MARRIAGE.SINGLE': '未婚',
  'MARRIAGE.MARRIED': '既婚',
  'MARRIAGE.DIVORCE': '離婚',
  'MARRIAGE.WIDOWED': '死別',
  'MARRIAGE.SEPARATION': '別居',

  'OCCUPATION.FREELANCER': 'フリーランス',
  'OCCUPATION.STUDENT': '学生',
  'OCCUPATION.CONSTRUCTION': '建設業',
  'OCCUPATION.FINANCE': '金融業',
  'OCCUPATION.AGRICULTURE': '農林漁業',
  'OCCUPATION.EDUCATION': '教育業',
  'OCCUPATION.MEDIA': 'マスコミ',
  'OCCUPATION.RELIGION': '宗教業',
  'OCCUPATION.HOSPITALITY': 'サービス業',
  'OCCUPATION.TECHNOLOGY': '情報通信業',
  'OCCUPATION.SPORTS': 'スポーツ',
  'OCCUPATION.HEALTHCARE': 'ヘルスケア',
  'OCCUPATION.TRANSPORTATION': '運輸業',

  'INTEREST.OUTDOORS': 'アウトドア',
  'INTEREST.SHOPPING': 'ショッピング・ファッション',
  'INTEREST.DINING': '飲食・グルメ',
  'INTEREST.TRAVEL': '旅行',
  'INTEREST.ENTERTAINMENT': '音楽・映画',
  'INTEREST.ARTS': '文化・芸術',
  'INTEREST.FITNESS': 'フィットネス',
  'INTEREST.TECHNOLOGY': 'テクノロジー',
  'INTEREST.LEARNING': '教育',
  'INTEREST.OTHERS': 'その他',

  'DIET.CARNIVORE': '肉食主義者',
  'DIET.ECO_VEGETARIAN': 'ビーガン',
  'DIET.RELIGIOUS_VEGETARIAN': 'ベジタリアン',
  'DIET.FLEXIBLE': 'ゆるベジタリアン',

  'TAIWAN.CITY': '',

  'EDUCATION.JUNIOR': '中学以下',
  'EDUCATION.SENIOR': '高校・専門学校',
  'EDUCATION.BACHELOR': '学士',
  'EDUCATION.MASTER': '修士以上',

  'MPS.SOURCE.8': 'シリアルコード交換',

  'MPS.EVENT.COLLECT': 'ポイント獲得',
  'MPS.EVENT.REDEEM': 'ポイント控除',
  'MPS.EVENT.0': 'ポイント付与条件未達',
  'MPS.EVENT.1': '金額達成ポイント付与',
  'MPS.EVENT.2': '誕生日ボーナス',
  'MPS.EVENT.3': '会員ボーナス',
  'MPS.EVENT.4': '柔軟ポイント付与',
  'MPS.EVENT.5': '誕生日ボーナス',
  'MPS.EVENT.6': '会員ボーナス',
  'MPS.EVENT.7': '初期ポイント付与',
  'MPS.EVENT.8': '購入割引ポイント付与',
  'MPS.EVENT.9': 'ギフト受領',
  'MPS.EVENT.10': '柔軟ポイント控除',
  'MPS.EVENT.11': '現金割引',
  'MPS.EVENT.12': '期間限定ボーナス',
  'MPS.EVENT.13': '会員紹介キャンペーン',
  'MPS.EVENT.14': '会員紹介登録',
  'MPS.EVENT.15': 'マーケティング活動のポイント付与',
  'MPS.EVENT.16': 'オンラインアンケートのポイント付与',
  'MPS.EVENT.17': 'シリアルコード交換',
  'MPS.EVENT.20': '交換-自動クーポン変換',
  'MPS.EVENT.21': '交換-自由クーポン選択',
  'MPS.EVENT.30': '友達に贈呈',
  'MPS.EVENT.31': 'ポイント調整控除',
  'MPS.EVENT.51': 'ポイント調整付与',
  'MPS.EVENT.52': '管理画面補填ポイント付与',
  'MPS.EVENT.53': '取引キャンセル-クーポン回収ポイント返還',
  'MPS.EVENT.54': 'ボーナスポイント',
  'MPS.EVENT.55': 'バースデープレゼント',
  'MPS.EVENT.56': '入会特典',
  'MPS.EVENT.57': 'ランクアップ特典',
  'MPS.EVENT.91': '取引キャンセル-金額達成ポイント',
  'MPS.EVENT.92': '取引キャンセル-誕生日ボーナス',
  'MPS.EVENT.93': '取引キャンセル-会員ボーナス',
  'MPS.EVENT.94': 'ランクアップ特典相当ポイント控除',
  'MPS.EVENT.95': 'バースデープレゼント相当ポイント控除',
  'MPS.EVENT.96': 'クーポン相当ポイント控除',
  'MPS.EVENT.97': '取引キャンセル-期間限定ボーナス',
  'MPS.EVENT.99': 'ポイント有効期限切れ',
  'MPS.EVENT.100': '取引キャンセル - マーケティング活動',

  'COLLECT.EVENT.0': 'ポイント付与不適合',
  'COLLECT.EVENT.1': '金額達成ポイント付与',
  'COLLECT.EVENT.4': '柔軟ポイント付与',
  'COLLECT.EVENT.10': '柔軟ポイント控除',
  'COLLECT.EVENT.20': '自動クーポン変換',
  'COLLECT.EVENT.21': '自由クーポン選択',
  'COLLECT.EVENT.90': 'ポイント収集キャンセル',
  'COLLECT.EVENT.91': '取引キャンセルによるポイント控除',
  'COLLECT.EVENT.92': '取引キャンセル-自動クーポン変換ポイント返還',
  'COLLECT.EVENT.93': 'ポイント付与キャンセル',
  'COLLECT.EVENT.94': 'ポイント控除キャンセル',
} as Record<string, any>;
